/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierClaimNotice } from "./CarrierClaimNotice";
import {
  CarrierClaimNoticeFromJSON,
  CarrierClaimNoticeFromJSONTyped,
  CarrierClaimNoticeToJSON,
  CarrierClaimNoticeToJSONTyped,
} from "./CarrierClaimNotice";
import type { FreightClaimReadModel } from "./FreightClaimReadModel";
import {
  FreightClaimReadModelFromJSON,
  FreightClaimReadModelFromJSONTyped,
  FreightClaimReadModelToJSON,
  FreightClaimReadModelToJSONTyped,
} from "./FreightClaimReadModel";

/**
 *
 * @export
 * @interface ClaimsTabData
 */
export interface ClaimsTabData {
  /**
   *
   * @type {Array<FreightClaimReadModel>}
   * @memberof ClaimsTabData
   */
  claims: Array<FreightClaimReadModel>;
  /**
   *
   * @type {CarrierClaimNotice}
   * @memberof ClaimsTabData
   */
  carrierClaimNotice?: CarrierClaimNotice | null;
}

/**
 * Check if a given object implements the ClaimsTabData interface.
 */
export function instanceOfClaimsTabData(value: object): value is ClaimsTabData {
  if (!("claims" in value) || value["claims"] === undefined) return false;
  return true;
}

export function ClaimsTabDataFromJSON(json: any): ClaimsTabData {
  return ClaimsTabDataFromJSONTyped(json, false);
}

export function ClaimsTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClaimsTabData {
  if (json == null) {
    return json;
  }
  return {
    claims: (json["claims"] as Array<any>).map(FreightClaimReadModelFromJSON),
    carrierClaimNotice:
      json["carrierClaimNotice"] == null
        ? undefined
        : CarrierClaimNoticeFromJSON(json["carrierClaimNotice"]),
  };
}

export function ClaimsTabDataToJSON(json: any): ClaimsTabData {
  return ClaimsTabDataToJSONTyped(json, false);
}

export function ClaimsTabDataToJSONTyped(
  value?: ClaimsTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    claims: (value["claims"] as Array<any>).map(FreightClaimReadModelToJSON),
    carrierClaimNotice: CarrierClaimNoticeToJSON(value["carrierClaimNotice"]),
  };
}
